import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuillViewHTMLComponent } from 'ngx-quill';
import { FormField } from '../models/form.model';

@Component({
  selector: 'app-form-description-field',
  standalone: true,
  imports: [CommonModule, QuillViewHTMLComponent],
  template: `
    <div class="form-group description-field">
      <label *ngIf="field.label" class="form-label">{{ field.label }}</label>
      <quill-view-html 
        class="quill-no-pad description-content" 
        [content]="field.defaultValue || ''" 
        theme="snow">
      </quill-view-html>
    </div>
  `,
  styles: [`
    .description-field { margin-bottom: 1.5rem; }
    .form-label { font-weight: 500; display: block; margin-bottom: 0.5rem; }
    .description-content { color: #495057; line-height: 1.6; }
  `]
})
export class FormDescriptionFieldComponent implements OnInit {
  @Input() field!: FormField;
  @Input() value: string | undefined; // Not used, but keeps interface consistent
  @Output() valueChange = new EventEmitter<string>(); // Never emits
  @Output() errorChange = new EventEmitter<any>(); // Always emits null

  ngOnInit(): void {
    this.errorChange.emit(null); // No validation for display-only
  }
}
